import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import spinnerLoading from '@/components/spinnerLoading'
import InfiniteLoading from 'vue-infinite-loading'
import vSelect from 'vue-select'
import mainTable from '@/components/table/mainTable'
import deletePopup from '@/components/modal/deleteModal'
import RoundedModalButton from '@/components/buttons/roundedModalButton'
import mainModal from '@/components/modal/mainModal'
import inputForm from '@/components/formElements/InputForm'
import inputCounter from '@/components/formElements/InputCounter'
import inputSwitch from '@/components/formElements/InputSwitch'
import mainSelect from '@/components/formElements/VSelect'

Vue.component('DatePicker', () => import('vue2-datepicker'))
Vue.component('DateRangePicker', () => import('vue2-daterange-picker'))
Vue.component('flat-pickr', () => import('vue-flatpickr-component'))
Vue.component('cropper-images', () => import('@/components/cropperImages'))
Vue.component('service-analysis', () => import('@/components/core/analysis/serviceAnalysis'))
Vue.component('welcome-page', () => import('@/components/welcomePage'))
Vue.component('Swiper', () => import('@/components/core/slider/Swiper'))
Vue.component('SwiperNav', () => import('@/components/core/slider/SwiperNav'))
Vue.component('SwiperSlide', () => import('@/components/core/slider/SwiperSlide'))
Vue.component('SliderThumbs', () => import('@/components/core/slider/sliderThumbs'))

Vue.component('multiselect', Multiselect)
Vue.component('spinner-loading', spinnerLoading)
Vue.component('infinite-loading', InfiniteLoading)
Vue.component('v-select', vSelect)
Vue.component('mainTable', mainTable)
Vue.component('deletePopup', deletePopup)
Vue.component('main-modal', mainModal)
Vue.component('input-form', inputForm)
Vue.component('input-counter', inputCounter)
Vue.component('input-switch', inputSwitch)
Vue.component('main-select', mainSelect)
Vue.component('model-button', RoundedModalButton)
